// This file was automatically generated from appchart.refpanel.compareRefpanel.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.compareRefpanel');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.medOrderThread');
goog.require('el8.template.ptdata.ptAllergies');
goog.require('el8.template.ptdata.ptImmunizationDeclines');
goog.require('el8.template.ptdata.ptImmunizations');
goog.require('el8.template.ptdata.ptIntolerances');
goog.require('el8.template.ptdata.ptProblems');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.skeleton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="practice-select-pane el8PositionAbsolute el8CompareRefpanelNav el8OverflowAuto"><div class="no-collaborators-msg" style="display: none"><h4 class="noBorder padl15 padt10">No clinical profiles to compare</h4></div><div class="practice-list-container"><h4 class="noBorder padl15 padt10">Select Practice to Compare with:</h4><div class="tab-container"></div></div></div><div class="cp-details-pane el8RightNavContainer el8CompareRefpanelRight"><!--<div class="el8ProviderListNoResults care-team-no-member-prompt el8Hidden">You don’t have anyone in your Care Team yet. Add Care Team members to start accessing their shared chart information.<br /><a class="add-care-team-member-trigger" type="button">Add to Care Team</a></div>--><div><div class="cp-details-header-container"></div><div class="cp-details-container el8OverflowAuto"></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.refpanelTab = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="cp-info tabbed-nav-item ', soy.$$escapeHtml(opt_data.tabItemClass), '" data-tab="', soy.$$escapeHtml(opt_data.name), '"><span class="tabbed-nav-count ', soy.$$escapeHtml(opt_data.tabCountClass), '" data-tab="', soy.$$escapeHtml(opt_data.name), '"></span><p class="el8Bold el8CompareRefPanelTitle">', soy.$$escapeHtml(opt_data.collaborator.practiceName), '</p><p class="el8CompareRefPanelTitle">', soy.$$escapeHtml(opt_data.collaborator.physicianName), '</p>');
  if (opt_data.collaborator.specialtyCategories && opt_data.collaborator.specialtyCategories.length) {
    output.append('<p>');
    var cList4818 = opt_data.collaborator.specialtyCategories;
    var cListLen4818 = cList4818.length;
    for (var cIndex4818 = 0; cIndex4818 < cListLen4818; cIndex4818++) {
      var cData4818 = cList4818[cIndex4818];
      output.append('<span class="mr5 el8333">', soy.$$escapeHtml(cData4818.name), '</span>');
    }
    output.append('</p>');
  }
  output.append((opt_data.collaborator.lastSeen) ? '<p class="el8SystemText">Most recent visit note: ' + (soy.$$escapeHtml(opt_data.collaborator.lastSeen)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.collaborator.lastSeen)) : '') + '</p>' : '', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.CPDetailsHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CompareRefpanelHeader cp-details-header"><div class="el8FloatRight el8AlignRight"><button class="el8button cp-details-mark-reviewed-trigger">Acknowledge</button>');
  if (opt_data.collaborator.lastReviewTime) {
    output.append('<button class="el8button import-all-sections-trigger ml5" data-type="new">Import New &amp; Acknowledge</button>');
    el8.template.appchart.refpanel.compareRefpanel.lastReviewedInfo(opt_data.collaborator, output);
  } else {
    output.append('<button class="el8button import-all-sections-trigger ml5" data-type="all">Import Profile &amp; Acknowledge</button>');
  }
  output.append('</div><h3>', soy.$$escapeHtml(opt_data.collaborator.practiceName), '</h3><h4 class="noBorder">', soy.$$escapeHtml(opt_data.collaborator.physicianName), '</h4>');
  if (opt_data.collaborator.specialtyCategories && opt_data.collaborator.specialtyCategories.length) {
    output.append('<p>');
    var cList4847 = opt_data.collaborator.specialtyCategories;
    var cListLen4847 = cList4847.length;
    for (var cIndex4847 = 0; cIndex4847 < cListLen4847; cIndex4847++) {
      var cData4847 = cList4847[cIndex4847];
      output.append('<span class="mr5 el8333">', soy.$$escapeHtml(cData4847.name), '</span>');
    }
    output.append('</p>');
  }
  output.append('<p class="cp-details-jump-links padt25"><a class="mr10 jump-link" data-section="allergies">Allgy<span class="section-count"></span></a><a class="mr10 jump-link" data-section="intols">Intols<span class="section-count"></span></a><a class="mr10 jump-link" data-section="problems">Problems<span class="section-count"></span></a><a class="mr10 jump-link" data-section="history">Hx<span class="section-count"></span></a><a class="mr10 jump-link" data-section="perm-rx">Rx Meds<span class="section-count"></span></a><a class="mr10 jump-link" data-section="perm-otc">OTC Meds<span class="section-count"></span></a><a class="mr10 jump-link" data-section="temp-meds">Temp Meds<span class="section-count"></span></a><a class="jump-link" data-section="vaccines">Vacc<span class="section-count"></span></a></p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.jumpLinkCount = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.count) ? ' (' + soy.$$escapeHtml(opt_data.count) + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.CPDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CPCmpDetails"><ul><li class="el8CPCmpDetailSection">');
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'allergies', title: 'Allergies'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'intols', title: 'Drug Intolerances'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'problems', title: 'Problem List'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'history', title: 'History'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'perm-rx', title: 'Permanent Rx Meds'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'perm-otc', title: 'Permanent OTC Meds'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'temp-meds', title: 'Temporary'}, output);
  el8.template.appchart.refpanel.compareRefpanel.CPSectionStub({name: 'vaccines', title: 'Vaccines'}, output);
  output.append('</li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.CPSectionStub = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PositionRelative"><div class="el8HeaderButtonContainer"><button tabindex="-1" type="button" class="el8button el8ItemButton import-new-trigger" data-section="', soy.$$escapeHtml(opt_data.name), '">Import New</button><button tabindex="-1" type="button" class="el8button el8ItemButton import-all-trigger" data-section="', soy.$$escapeHtml(opt_data.name), '">Import All</button></div><h4 class="cp-', soy.$$escapeHtml(opt_data.name), '-summary-header el8SectionHeaderNoCollapse"><span id="cp-', soy.$$escapeHtml(opt_data.name), '-summary-status" class="el8Elt"></span>', soy.$$escapeHtml(opt_data.title), '</h4><div class="el8Loading cp-section cp-', soy.$$escapeHtml(opt_data.name), '-section" data-section="', soy.$$escapeHtml(opt_data.name), '"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.lastReviewedInfo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.lastReviewTime) ? '<p class="el8SystemText padt5">Last Reviewed ' + (soy.$$escapeHtml(opt_data.lastReviewTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.lastReviewTime)) : '') + '<br>by ' + soy.$$escapeHtml(opt_data.lastReviewUserName) + '</p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.allergySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol>');
  var itemList4914 = opt_data.items;
  var itemListLen4914 = itemList4914.length;
  if (itemListLen4914 > 0) {
    for (var itemIndex4914 = 0; itemIndex4914 < itemListLen4914; itemIndex4914++) {
      var itemData4914 = itemList4914[itemIndex4914];
      output.append('<li ');
      el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData4914.id, createDate: itemData4914.createDate, lastReviewTime: opt_data.lastReviewTime, duplicate: itemData4914.duplicate}, output);
      output.append('>');
      el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData4914.id, createDate: itemData4914.createDate, duplicate: itemData4914.duplicate}), output);
      output.append('<div class="el8InlineBlock w85"><p><span class="el8Preserve">');
      el8.template.ptdata.ptAllergies.summary(itemData4914, output);
      output.append('</span></p></div></li>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">');
    if (opt_data.isDocumented) {
      el8.template.ptdata.ptAllergies.documentedAsNoneSummary(null, output);
    } else {
      output.append('Not documented');
    }
    output.append('</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.problemSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol>');
  var itemList4941 = opt_data.items;
  var itemListLen4941 = itemList4941.length;
  if (itemListLen4941 > 0) {
    for (var itemIndex4941 = 0; itemIndex4941 < itemListLen4941; itemIndex4941++) {
      var itemData4941 = itemList4941[itemIndex4941];
      output.append('<li ');
      el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData4941.id, createDate: itemData4941.createDate, lastReviewTime: opt_data.lastReviewTime, status: itemData4941.status, duplicate: itemData4941.duplicate}, output);
      output.append('>');
      el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData4941.id, createDate: itemData4941.createDate, duplicate: itemData4941.duplicate}), output);
      output.append('<div class="el8InlineBlock w8"><p class="el8AppText">', soy.$$escapeHtml(itemData4941.year), '</p></div><div class="el8InlineBlock w77"><p><span class="el8Preserve">');
      el8.template.ptdata.ptProblems.detailedDescriptionWithResolvedStatus(itemData4941, output);
      output.append('</span></p>', (itemData4941.details) ? '<p class="padv3 ml10 el8ItalicText el8777">' + soy.$$escapeHtml(itemData4941.details) + '</p>' : '', '</div></li>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">');
    if (opt_data.isDocumented) {
      el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
    } else {
      output.append('Not documented');
    }
    output.append('</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.intolSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol>');
  var itemList4977 = opt_data.items;
  var itemListLen4977 = itemList4977.length;
  if (itemListLen4977 > 0) {
    for (var itemIndex4977 = 0; itemIndex4977 < itemListLen4977; itemIndex4977++) {
      var itemData4977 = itemList4977[itemIndex4977];
      output.append('<li ');
      el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData4977.id, createDate: itemData4977.createDate, lastReviewTime: opt_data.lastReviewTime, duplicate: itemData4977.duplicate}, output);
      output.append('>');
      el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData4977.id, createDate: itemData4977.createDate, duplicate: itemData4977.duplicate}), output);
      output.append('<div class="el8InlineBlock w75"><p><span class="el8Preserve">');
      el8.template.ptdata.ptIntolerances.summary(itemData4977, output);
      output.append('</span></p></div></li>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">');
    if (opt_data.isDocumented) {
      el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
    } else {
      output.append('Not documented');
    }
    output.append('</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.medThreadSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol>');
  var itemList5004 = opt_data.items;
  var itemListLen5004 = itemList5004.length;
  if (itemListLen5004 > 0) {
    for (var itemIndex5004 = 0; itemIndex5004 < itemListLen5004; itemIndex5004++) {
      var itemData5004 = itemList5004[itemIndex5004];
      output.append('<li ');
      el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData5004.id, createDate: itemData5004.latestOrder.createDate, lastReviewTime: opt_data.lastReviewTime, duplicate: itemData5004.duplicate}, output);
      output.append('>');
      el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData5004.id, createDate: itemData5004.latestOrder.createDate, duplicate: itemData5004.duplicate}), output);
      output.append('<div class="el8InlineBlock w15"><p class="el8AppText">', (soy.$$escapeHtml(itemData5004.startDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(itemData5004.startDate)) : ''), '</p></div><div class="el8InlineBlock w70"><p>');
      el8.template.ptdata.model.medOrderThread.summary(soy.$$augmentData(itemData5004, {hasTrigger: false}), output);
      output.append('</p></div></li>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">Not documented</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.medOrderSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol>');
  var itemList5029 = opt_data.items;
  var itemListLen5029 = itemList5029.length;
  if (itemListLen5029 > 0) {
    for (var itemIndex5029 = 0; itemIndex5029 < itemListLen5029; itemIndex5029++) {
      var itemData5029 = itemList5029[itemIndex5029];
      output.append('<li ');
      el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData5029.id, importId: itemData5029.threadId, createDate: itemData5029.createDate, lastReviewTime: opt_data.lastReviewTime, duplicate: itemData5029.duplicate}, output);
      output.append('>');
      el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData5029.threadId, createDate: itemData5029.createDate, duplicate: itemData5029.duplicate}), output);
      output.append('<div class="w15 el8InlineBlock"><p class="el8AppText">', (itemData5029.modelClass == 'MedOrder') ? (soy.$$escapeHtml(itemData5029.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(itemData5029.startDate)) : '') : (itemData5029.modelClass == 'DiscontinueMedOrder') ? (soy.$$escapeHtml(itemData5029.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(itemData5029.discontinueDate)) : '') : '', '</p></div><div class="el8InlineBlock w70"><p>');
      if (itemData5029.modelClass == 'MedOrder') {
        el8.template.ptdata.model.medOrder.refPanelSummary(soy.$$augmentData(itemData5029, {hasTrigger: false}), output);
      } else if (itemData5029.modelClass == 'DiscontinueMedOrder') {
        el8.template.ptdata.model.dcMedOrder.orderSummary(soy.$$augmentData(itemData5029, {hasTrigger: false}), output);
        output.append('</p>');
      }
      output.append('</p></div></li>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">Not documented</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.vaccineSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol>');
  var itemList5066 = opt_data.items;
  var itemListLen5066 = itemList5066.length;
  if (itemListLen5066 > 0) {
    for (var itemIndex5066 = 0; itemIndex5066 < itemListLen5066; itemIndex5066++) {
      var itemData5066 = itemList5066[itemIndex5066];
      output.append('<li ');
      el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData5066.id, createDate: itemData5066.createDate, lastReviewTime: opt_data.lastReviewTime, duplicate: itemData5066.duplicate}, output);
      output.append('>');
      el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData5066.id, createDate: itemData5066.createDate, duplicate: itemData5066.duplicate}), output);
      output.append('<div class="el8InlineBlock w75"><p>');
      if (itemData5066.modelClass == 'PatientImmunization') {
        el8.template.ptdata.ptImmunizations.summary(itemData5066, output);
      } else if (itemData5066.modelClass == 'PatientImmunizationDecline') {
        el8.template.ptdata.ptImmunizationDeclines.summary(itemData5066, output);
      }
      output.append('</p></div></li>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">Not documented</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.historySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var pairList5090 = opt_data.pairs;
  var pairListLen5090 = pairList5090.length;
  if (pairListLen5090 > 0) {
    for (var pairIndex5090 = 0; pairIndex5090 < pairListLen5090; pairIndex5090++) {
      var pairData5090 = pairList5090[pairIndex5090];
      output.append('<h4 class="ml10 ', (! (pairIndex5090 == 0)) ? 'mt10' : '', '">');
      el8.template.appchart.refpanel.compareRefpanel.historyTitle({sectionName: pairData5090[0]}, output);
      output.append('</h4><ol>');
      el8.template.appchart.refpanel.compareRefpanel.historyItems(soy.$$augmentData(opt_data, {sectionName: pairData5090[0], items: pairData5090[1]}), output);
      output.append('</ol>');
    }
  } else {
    output.append('<li class="el8SectionEmpty">Not documented</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.historyItems = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList5107 = opt_data.items;
  var itemListLen5107 = itemList5107.length;
  for (var itemIndex5107 = 0; itemIndex5107 < itemListLen5107; itemIndex5107++) {
    var itemData5107 = itemList5107[itemIndex5107];
    output.append('<li ');
    el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes({itemId: itemData5107.id, createDate: itemData5107.createDate, lastReviewTime: opt_data.lastReviewTime, duplicate: itemData5107.duplicate}, output);
    output.append('>');
    el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata(soy.$$augmentData(opt_data, {itemId: itemData5107.id, createDate: itemData5107.createDate, duplicate: itemData5107.duplicate}), output);
    output.append('<div class="el8InlineBlock w75"><p class="el8Preserve el8MoreLineHeight">');
    if (opt_data.sectionName == 'family' && itemData5107.modelClass == 'PatientFamilyRelationship') {
      el8.template.appchart.refpanel.compareRefpanel.structuredFamilyHistoryItem(itemData5107, output);
    } else if (itemData5107.modelClass == 'ClinicalFormCollection') {
      output.append(soy.$$escapeHtml(itemData5107.collectionSummary));
    } else {
      output.append(soy.$$escapeHtml(itemData5107.text));
    }
    output.append('</p></div></li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.historyTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.sectionName) {
    case 'past':
      output.append('PMH');
      break;
    case 'surgical':
      output.append('PSH');
      break;
    case 'family':
      output.append('FH');
      break;
    case 'social':
      output.append('SH');
      break;
    case 'cognitive':
      output.append('Cogn');
      break;
    case 'functional':
      output.append('Func');
      break;
    case 'habits':
      output.append('Habits');
      break;
    case 'diet':
      output.append('Diet');
      break;
    case 'exercise':
      output.append('Exercise');
      break;
    case 'maintenance':
      output.append('Maint');
      break;
    case 'legal':
      output.append('Legal');
      break;
    case 'immunization':
      output.append('Vacc');
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.structuredFamilyHistoryItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8Bold">', soy.$$escapeHtml(opt_data.relationshipTypeName), ':</span>');
  var familyHistoryItemList5159 = opt_data.items;
  var familyHistoryItemListLen5159 = familyHistoryItemList5159.length;
  for (var familyHistoryItemIndex5159 = 0; familyHistoryItemIndex5159 < familyHistoryItemListLen5159; familyHistoryItemIndex5159++) {
    var familyHistoryItemData5159 = familyHistoryItemList5159[familyHistoryItemIndex5159];
    output.append('<p class="el8MoreLineHeight ml10"> - ', soy.$$escapeHtml(familyHistoryItemData5159.textOrCodeDescription), '</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.patientItemAttributes = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('class="', (el8.util.datecompare.cmp( new Date(opt_data.createDate), new Date(opt_data.lastReviewTime) ) == 1 && ! opt_data.duplicate) ? 'el8CompareRefpanelHighlightItem new-profile-item' : '', (opt_data.status == 'Resolved' || opt_data.status == 'Controlled' || opt_data.status == 'Inactive') ? ' el8999' : '', ' el8ItemHover profile-item el8CompareRefPanelListItem" data-id="', soy.$$escapeHtml(opt_data.itemId), '" data-import-id="', (opt_data.importId) ? soy.$$escapeHtml(opt_data.importId) : soy.$$escapeHtml(opt_data.itemId), '"');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.compareRefpanel.itemLeftMetadata = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8InlineBlock w10"><button class="el8button el8ItemButton import-trigger" data-id="', soy.$$escapeHtml(opt_data.itemId), '">import</button></div><div class="el8InlineBlock w3">', (el8.util.datecompare.cmp( new Date(opt_data.createDate), new Date(opt_data.lastReviewTime) ) == 1 && ! opt_data.duplicate) ? '<span class="el8FeedItemNewPlrMarker"></span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
